import React, { useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";

const BlogDashboard = () => {

  const [blogs, setBlogs] = useState([]);

  const [form, setForm] = useState({
    title: "",
    content: "",
    section1: "",
    section2: "",
  });

  const [files, setFiles] = useState({
    image: null,
    sub_image1: null,
    sub_image2: null,
  });

  // ✅ EDIT STATES
  const [editId, setEditId] = useState(null);

  const [isEditing, setIsEditing] = useState(false);

  // ✅ LOADING
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ✅ MESSAGE
  const [message, setMessage] = useState("");

  const [messageType, setMessageType] = useState("");

  // ✅ HYPERLINKS
  const [links, setLinks] = useState([
    {
      word: "",
      url: "",
    },
  ]);

  useEffect(() => {
    fetchBlogs();
  }, []);

  // ================= FETCH BLOGS =================

  const fetchBlogs = async () => {

    try {

      const res = await fetch(
        "https://admin.drgargevascular.com/backend/blogs"
      );

      const data = await res.json();

      setBlogs(data);

    } catch (err) {

      console.log(err);
    }
  };

  // ================= INPUT CHANGE =================

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // ================= FILE CHANGE =================

  const handleFileChange = (e) => {

    setFiles({
      ...files,
      [e.target.name]: e.target.files[0],
    });
  };

  // ================= LINK CHANGE =================

  const handleLinkChange = (index, field, value) => {

    const updated = [...links];

    updated[index][field] = value;

    setLinks(updated);
  };

  // ================= ADD MORE LINKS =================

  const addMoreLink = () => {

    setLinks([
      ...links,
      {
        word: "",
        url: "",
      },
    ]);
  };

  // ================= EDIT BLOG =================

 const handleEdit = (blog) => {

  setIsEditing(true);

  setEditId(blog.id);

  setForm({
    title: blog.title || "",
    content: blog.content || "",
    section1: blog.section1 || "",
    section2: blog.section2 || "",
  });

  // ✅ SAFE PARSE LINKS

  let parsedLinks = [];

  try {

    if (Array.isArray(blog.content_links)) {

      parsedLinks = blog.content_links;

    } else if (typeof blog.content_links === "string") {

      parsedLinks = JSON.parse(blog.content_links);

    }

  } catch (err) {

    console.log("LINK PARSE ERROR:", err);

    parsedLinks = [];

  }

  setLinks(
    parsedLinks.length
      ? parsedLinks
      : [
          {
            word: "",
            url: "",
          },
        ]
  );

  setFiles({
    image: null,
    sub_image1: null,
    sub_image2: null,
  });

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

  // ================= SUBMIT =================

  const handleSubmit = async (e) => {

    e.preventDefault();

    // ✅ STOP MULTIPLE SUBMIT
    if (isSubmitting) return;

    try {

      setIsSubmitting(true);

      setMessage("");

      const formData = new FormData();

      formData.append("title", form.title);

      formData.append("content", form.content);

      formData.append("section1", form.section1);

      formData.append("section2", form.section2);

      // ✅ VALID LINKS ONLY
      const validLinks = links.filter(
        (item) =>
          item.word.trim() !== "" &&
          item.url.trim() !== ""
      );

      formData.append(
        "content_links",
        JSON.stringify(validLinks)
      );

      // ✅ FILES
      if (files.image) {
        formData.append("image", files.image);
      }

      if (files.sub_image1) {
        formData.append("sub_image1", files.sub_image1);
      }

      if (files.sub_image2) {
        formData.append("sub_image2", files.sub_image2);
      }

      // ================= UPDATE =================

      if (isEditing) {

        await fetch(
          `https://admin.drgargevascular.com/backend/blogs/${editId}`,
          {
            method: "PUT",
            body: formData,
          }
        );

        setMessage("✅ Blog updated successfully");

      } else {

        // ================= ADD =================

        await fetch(
          "https://admin.drgargevascular.com/backend/blogs",
          {
            method: "POST",
            body: formData,
          }
        );

        setMessage("✅ Blog added successfully");
      }

      setMessageType("success");

      // RESET

      setForm({
        title: "",
        content: "",
        section1: "",
        section2: "",
      });

      setFiles({
        image: null,
        sub_image1: null,
        sub_image2: null,
      });

      setLinks([
        {
          word: "",
          url: "",
        },
      ]);

      setEditId(null);

      setIsEditing(false);

      fetchBlogs();

    } catch (err) {

      console.log(err);

      setMessage("❌ Something went wrong");

      setMessageType("danger");

    } finally {

      setIsSubmitting(false);

      setTimeout(() => {
        setMessage("");
      }, 3000);
    }
  };

  // ================= DELETE =================

  const handleDelete = async (id) => {

    try {

      await fetch(
        `https://admin.drgargevascular.com/backend/blogs/${id}`,
        {
          method: "DELETE",
        }
      );

      setBlogs(
        blogs.filter((b) => b.id !== id)
      );

      setMessage("✅ Blog deleted successfully");

      setMessageType("success");

    } catch (err) {

      console.log(err);

      setMessage("❌ Delete failed");

      setMessageType("danger");
    }

    setTimeout(() => {
      setMessage("");
    }, 3000);
  };

  return (
    <>
      <PageTitle
        activeMenu="Blogs"
        motherMenu="Dashboard"
      />

      <div className="row">

        {/* ================= FORM ================= */}

        <div className="col-xl-12">

          <div
            className="card border-0 shadow-sm"
            style={{
              borderRadius: "16px",
            }}
          >

            <div
              className="card-header bg-white border-0"
              style={{
                borderRadius: "16px 16px 0 0",
              }}
            >

              <h4 className="mb-0 fw-bold">

                {isEditing
                  ? "Edit Blog"
                  : "Add Blog"}

              </h4>

            </div>

            <div className="card-body">

              {/* ================= ALERT ================= */}

              {
                message && (
                  <div
                    className={`alert alert-${messageType} border-0 shadow-sm`}
                    style={{
                      borderRadius: "12px",
                      fontWeight: "600",
                    }}
                  >
                    {message}
                  </div>
                )
              }

              <form onSubmit={handleSubmit}>

                {/* MAIN IMAGE */}

                <label className="fw-semibold mb-2">
                  Main Image
                </label>

                <input
                  type="file"
                  name="image"
                  className="form-control mb-4"
                  onChange={handleFileChange}
                  required={!isEditing}
                />

                {/* TITLE */}

                <label className="fw-semibold mb-2">
                  Title
                </label>

                <input
                  type="text"
                  name="title"
                  placeholder="Enter Blog Title"
                  className="form-control mb-4"
                  value={form.title}
                  onChange={handleChange}
                  required
                />

                {/* CONTENT */}

                <label className="fw-semibold mb-2">
                  Main Content
                </label>

                <textarea
                  name="content"
                  className="form-control mb-4"
                  rows="8"
                  placeholder="Enter Main Blog Content"
                  value={form.content}
                  onChange={handleChange}
                  required
                ></textarea>

                {/* SECTION 1 */}

                <label className="fw-semibold mb-2">
                  Section 1
                </label>

                <textarea
                  name="section1"
                  className="form-control mb-4"
                  rows="6"
                  placeholder="Enter Section 1"
                  value={form.section1}
                  onChange={handleChange}
                ></textarea>

                {/* SUB IMAGE 1 */}

                <label className="fw-semibold mb-2">
                  Sub Image 1
                </label>

                <input
                  type="file"
                  name="sub_image1"
                  className="form-control mb-4"
                  onChange={handleFileChange}
                />

                {/* SUB IMAGE 2 */}

                <label className="fw-semibold mb-2">
                  Sub Image 2
                </label>

                <input
                  type="file"
                  name="sub_image2"
                  className="form-control mb-4"
                  onChange={handleFileChange}
                />

                {/* SECTION 2 */}

                <label className="fw-semibold mb-2">
                  Section 2
                </label>

                <textarea
                  name="section2"
                  className="form-control mb-4"
                  rows="6"
                  placeholder="Enter Section 2"
                  value={form.section2}
                  onChange={handleChange}
                ></textarea>

                {/* ================= LINKS ================= */}

                <hr className="my-4" />

                <h5 className="fw-bold mb-4">
                  Add Hyperlinks
                </h5>

                {links.map((item, index) => (

                  <div
                    key={index}
                    className="border rounded p-3 mb-3"
                    style={{
                      borderColor: "#e9ecef",
                      background: "#fafafa",
                    }}
                  >

                    <input
                      type="text"
                      placeholder="Word/Text To Highlight"
                      className="form-control mb-3"
                      value={item.word}
                      onChange={(e) =>
                        handleLinkChange(
                          index,
                          "word",
                          e.target.value
                        )
                      }
                    />

                    <input
                      type="text"
                      placeholder="Redirect URL"
                      className="form-control"
                      value={item.url}
                      onChange={(e) =>
                        handleLinkChange(
                          index,
                          "url",
                          e.target.value
                        )
                      }
                    />

                  </div>
                ))}

                {/* ADD MORE */}

                <button
                  type="button"
                  className="btn btn-info text-white mb-4"
                  onClick={addMoreLink}
                  style={{
                    borderRadius: "10px",
                    fontWeight: "600",
                  }}
                >
                  + Add More Hyperlink
                </button>

                <br />

                {/* SUBMIT */}

                <button
                  className="btn btn-primary px-5"
                  disabled={isSubmitting}
                  style={{
                    height: "48px",
                    borderRadius: "12px",
                    fontWeight: "600",
                    minWidth: "200px",
                  }}
                >

                  {isSubmitting
                    ? "Please Wait..."
                    : isEditing
                    ? "Update Blog"
                    : "Add Blog"}

                </button>

              </form>

            </div>

          </div>

        </div>

        {/* ================= BLOG LIST ================= */}

        <div className="col-xl-12 mt-4">

          <div
            className="card border-0 shadow-sm"
            style={{
              borderRadius: "16px",
            }}
          >

            <div className="card-header bg-white border-0">
              <h4 className="fw-bold mb-0">
                All Blogs
              </h4>
            </div>

            <div className="card-body">

              <div className="row">

                {blogs.map((blog) => (

                  <div
                    className="col-lg-4 mb-4"
                    key={blog.id}
                  >

                    <div
                      className="card h-100 border-0 shadow-sm"
                      style={{
                        borderRadius: "16px",
                        overflow: "hidden",
                      }}
                    >

                      {/* IMAGE */}

                      <img
                        src={`https://admin.drgargevascular.com/backend${blog.image}`}
                        style={{
                          height: "220px",
                          objectFit: "cover",
                        }}
                        alt=""
                      />

                      <div className="card-body d-flex flex-column">

                        {/* TITLE */}

                        <h5
                          className="fw-bold"
                          style={{
                            lineHeight: "28px",
                          }}
                        >
                          {blog.title}
                        </h5>

                        {/* CONTENT */}

                        <p
                          style={{
                            fontSize: "14px",
                            color: "#666",
                            flex: 1,
                            lineHeight: "26px",
                          }}
                        >
                          {blog.content?.substring(0, 120)}...
                        </p>

                        {/* BUTTONS */}

                        <div className="d-flex gap-2 mt-3">

                          <button
                            onClick={() =>
                              handleEdit(blog)
                            }
                            className="btn btn-primary btn-sm"
                            style={{
                              borderRadius: "8px",
                              fontWeight: "600",
                            }}
                          >
                            Edit
                          </button>

                          <button
                            onClick={() =>
                              handleDelete(blog.id)
                            }
                            className="btn btn-danger btn-sm"
                            style={{
                              borderRadius: "8px",
                              fontWeight: "600",
                            }}
                          >
                            Delete
                          </button>

                        </div>

                      </div>

                    </div>

                  </div>
                ))}

              </div>

            </div>

          </div>

        </div>

      </div>
    </>
  );
};

export default BlogDashboard;